import { NodeToolbar, NodeToolbarProps } from '@xyflow/react';
import { Paper, SxProps } from '@mui/material';
import React from 'react';

interface CanvasNodeToolbarProps extends NodeToolbarProps {
  children: React.ReactNode;
  paperSx?: SxProps;
  hide?: boolean;
}

const defaultPaperStyles: SxProps = {
  backgroundColor: 'white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  padding: '4px 4px',
  gap: '4px',
};

export const CanvasNodeToolbar = ({
  children,
  paperSx,
  hide: hide,
  ...nodeToolbarProps
}: CanvasNodeToolbarProps) => {
  return (
    <NodeToolbar {...nodeToolbarProps}>
      <Paper sx={{ ...defaultPaperStyles, ...paperSx, opacity: hide ? 0 : 1 }}>{children}</Paper>
    </NodeToolbar>
  );
};
